module.exports = __webpack_public_path__ + "img/plage.1b2e0bcf.jpg";